import { billingsService, creditNoteService } from "@/_services";
import jsPDF from "jspdf";
import "jspdf-autotable";
import i18n from "@/_helpers/i18n";

/**
 * Mixin para generar PDF de facturas
 * Soporta dos estructuras de items:
 * 1. Items legacy: { name, lastname, business_name, event_date, amount }
 * 2. Items nuevos (payment_item): { description, qty, amount }
 */
export const pdfInvoiceMixin = {
  methods: {
    downloadPDF(payment) {
      billingsService
        .downloadPDF(payment.id)
        .then((result) => {
          const pdf = new jsPDF("p", "pt", [595.28, 841.89]);
          const logo = require("@/assets/images/logo-h.png");
          const logo_factura = require("@/assets/images/facture_protegee.png");
          // console.log(result);

          const doc = new jsPDF();
          var imgLogo = new Image();
          imgLogo.src = logo;

          pdf.addImage(imgLogo, "JPEG", 40, 50, 185, 50);

          // imgLogo.src = logo_factura

          // pdf.addImage(imgLogo, 'JPEG', 375, 34, 184, 80);

          // pdf.setFontSize(26);
          // pdf.setTextColor(81, 85, 236);
          // pdf.text(400, 40, 'OLIVERLIST');

          pdf.setFontSize(9);
          pdf.setTextColor(150);
          pdf.text(502, 180, "AIVONI SAS");
          pdf.text(445, 192, "231 RUE SAINT-HONORE");
          pdf.text(498, 204, "75001 PARIS");
          pdf.text(447, 216, "N° Siret: 80878516600048");
          pdf.text(501, 228, "NAF: 58.29C");
          pdf.text(436, 240, "EU VAT N°: FR32808785166");

          // pdf.setDrawColor(81, 85, 236);
          // pdf.setFillColor(81, 85, 236);
          // pdf.rect(0, 150, 250, 20, 'F');

          pdf.setFontSize(22);
          pdf.setFont("bold");
          pdf.setTextColor(95, 95, 95);
          pdf.text(42, 164, "INVOICE");
          pdf.setTextColor(81, 85, 236);
          pdf.text(2, 167, "_______________________");

          pdf.setTextColor(100);

          let invoice = result.data;
          let data = result.data;
          let d = new Date(invoice.created);
          let year_digits = d.getFullYear().toString().substr(-2);
          let invoiceId =
            year_digits +
            "OL" +
            invoice.invoice_id.toString().padStart(10, "0");
          pdf.setFont("normal");
          pdf.setFontSize(11);
          pdf.text(40, 185, "Invoice number: " + invoiceId);

          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          let year = d.getFullYear().toString();
          let invoiceDate =
            d.getDate() + " " + monthNames[d.getMonth()] + ", " + year;
          pdf.text(40, 200, "Invoice date: " + invoiceDate);

          if (invoice.ingenico_pay_id != undefined) {
            pdf.text(40, 215, "Billing id: " + invoice.ingenico_pay_id);
          }

          let client = result.data;
          if (client.name) {
            pdf.setFontSize(12);
            pdf.setTextColor(150);
            pdf.text(40, 230, "Invoice to: ");
            pdf.setFontSize(10);
            pdf.setFont("bold");
            pdf.text(40, 245, client.name);
            pdf.setFont("normal");
            pdf.text(40, 260, client.legal_representative);
            pdf.text(40, 275, client.address);
            pdf.text(40, 290, client.country);
          }

          if (invoice.vat_number != undefined) {
            pdf.text(40, 305, "EU VAT N°: " + invoice.vat_number);
          }

          pdf.autoTableSetDefaults({
            headStyles: { fillColor: [81, 85, 236] }, // Purple
          });

          var total = Number(result.data.total);
          var discount_amount = result.data.discount_amount || 0;
          var discount_previous_payment =
            result.data.discount_previous_payment || 0;
          total = (total - discount_amount - discount_previous_payment).toFixed(
            2
          );

          var percentage = result.data.vat || 0;
          var totalWithVat = result.data.total_with_vat || 0;
          var totalVat = result.data.total_vat || 0;

          result.data.total = total + " €";

          let discount = ((result.data.discount * 100) / 100).toFixed(0);
          let discount_data = {};

          let discount_previous_payment_data = {};

          if (discount_previous_payment > 0) {
            discount_previous_payment_data = {
              date: "Prorata refund old plan",
              total: "- " + discount_previous_payment + " €",
            };
          }

          if (discount > 0) {
            discount_data = {
              date: "Remise (" + discount + " %)",
              total: "- " + result.data.discount_amount + " €",
            };
          }

          let items = [];

          // Procesar items de la factura (desde payment_item)
          if (result.data.items && Array.isArray(result.data.items)) {
            result.data.items.forEach((item, key) => {
              // Manejo flexible: info para las reuniones
              if (item.event_date) {
                let description =
                  "[" +
                  (item.name || "") +
                  " " +
                  (item.lastname || "") +
                  "] " +
                  (item.business_name || "") +
                  " " +
                  (item.event_date || "") +
                  " ( " +
                  (item.amount || "") +
                  " € ) ";

                items.push({
                  date: "",
                  description: description,
                  total: "",
                });
              }
              // Manejo nuevo: si tiene campos de payment_item (description, qty, amount)
              else if (item.service_type) {
                const translationKey =
                  "lang.invoice.service_type." + item.service_type ||
                  "lang.invoice.service_type.default";
                let description = (item.service_type == "custom" ? "" : i18n.t(translationKey)) +
                  (item.description ? item.description : "") +
                  (key == 0 ? " - " + result.data.client_name : "") +
                  (key == 0
                    ? " - " +
                      (result.data.payment_method_description
                        ? " (" + result.data.payment_method_description + ")"
                        : "")
                    : "") +
                  (item.qty > 1
                    ? " ( " + item.qty + " x " + item.amount + "€ )"
                    : "");
                items.push({
                  date: "",
                  description: description,
                  total: item.amount
                    ? (Number(item.amount) * (item.qty || 1)).toFixed(2) + " €"
                    : "",
                });
              }
            });
          }

          let lines = [];

          // Agregar items (el primero será la primera fila visible)
          if (items.length > 0) {
            // Agregar fecha al primer item
            items[0].date = data.invoice_date || "";
            // Marcar todos los items como bold
            items.forEach((item) => {
              if (item.service_type) {
                item._isBold = true;
              }
            });
            lines = lines.concat(items);
          }

          // Agregar descuentos
          lines = lines.concat([discount_previous_payment_data, discount_data]);

          pdf.autoTable({
            startY: 320,
            body: lines,
            columns: [
              { header: "Date", dataKey: "date" },
              { header: "Description", dataKey: "description" },
              { header: "Total in EUR", dataKey: "total" },
            ],
            columnStyles: {
              2: { halign: "right" },
            },
            didDrawCell: function (hookData) {
              if (hookData.section === "body") {
                // Bold para el primer elemento (encabezado de datos)
                var currentLine = lines[hookData.row.index];
                if (
                  hookData.row.index === 0 ||
                  (currentLine && currentLine._isBold)
                ) {
                  for (const cell of Object.values(hookData.row.cells)) {
                    cell.styles.fontStyle = "bold";
                  }
                }

                // Bold para los descuentos (últimas 2 filas)
                const isDiscountRow = hookData.row.index >= lines.length - 2;
                if (isDiscountRow && currentLine && currentLine.total) {
                  for (const cell of Object.values(hookData.row.cells)) {
                    cell.styles.fontStyle = "bold";
                  }
                }
              }
            },
          });

          var body = [];
          body.push({ field: "Subtotal in EUR", value: total + " €" });
          body.push({
            field: "VAT (" + percentage + "%)",
            value: totalVat + " €",
          });
          body.push({ field: "Total in EUR", value: totalWithVat + " €" });
          pdf.autoTable({
            startY: pdf.lastAutoTable.finalY + 40,
            tableWidth: 200,
            theme: "grid",
            minCellHeight: 30,
            margin: { left: 350 },
            head: [{ field: "", value: "" }],
            body: body,
            showHead: false,
            columnStyles: {
              field: { fontStyle: "bold", cellPadding: 7 },
              value: { cellPadding: 7, halign: "right" },
            },
          });

          //pdf.setFont("bold");
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          if (data.payment_date != null) {
            // let CollectionId
            let paymentDate = new Date(data.payment_date);
            const paymentYear = paymentDate.getFullYear().toString().substr(-2);
            const paymentMonth = String(paymentDate.getMonth() + 1).padStart(
              2,
              "0"
            );
            const paymentDay = String(paymentDate.getDay() + 1).padStart(
              2,
              "0"
            );
            let collectionId = paymentDay + paymentMonth + paymentYear;
            pdf.text(
              40,
              pdf.lastAutoTable.finalY + 20,
              "Collection id: " + collectionId
            );
          }
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 35,
            "The invoice was generated electronically and automatically, without a cash register."
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 50,
            "This is the original electronic version."
          );

          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 65,
            "Payment Date: " + invoiceDate
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 80,
            "Payment method: Credit card "
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 95,
            "Discount conditions: No discount is applied."
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 110,
            "Penalty conditions: Any delay in payment of the invoice will result in the immediate application of an annual interest rate of  "
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 125,
            "12% on the unpaid amounts as well as 40 € for collection costs, in accordance with art L 4414-10 of the French Commercial Code."
          );

          let vat_info = "TVA non applicable – art. 259-1 du CGI";
          if (invoice.country_id == "73" || Number(invoice.vat) > 0) {
            vat_info = "TVA Applicable";
          } else if (
            [
              "14",
              "21",
              "33",
              "54",
              "56",
              "57",
              "58",
              "67",
              "72",
              "80",
              "83",
              "97",
              "103",
              "105",
              "117",
              "123",
              "124",
              "132",
              "150",
              "171",
              "172",
              "176",
              "193",
              "194",
              "199",
              "205",
            ].includes(String(invoice.country_id))
          ) {
            vat_info = "Autoliquidation – TVA due par le preneur, art. 283-2 du CGI";
          }
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 140,
            "VAT information: " + vat_info
          );

          pdf.save("invoice-" + invoiceId + ".pdf");
        })
        .catch((error) => {
          console.error("Error descargando PDF:", error);
        });
    },
    downloadCreditNotePDF(creditNote) {
      if (!creditNote || creditNote.id == null) {
        return;
      }
      creditNoteService
        .getCreditNoteById(creditNote.id)
        .then((raw) => {
          const cn = raw && raw.data != null ? raw.data : raw;

          const pdf = new jsPDF("p", "pt", [595.28, 841.89]);
          const logo = require("@/assets/images/logo-h.png");
          const imgLogo = new Image();
          imgLogo.src = logo;

          pdf.addImage(imgLogo, "JPEG", 40, 50, 185, 50);

          pdf.setFontSize(9);
          pdf.setTextColor(150);
          pdf.text(502, 180, "AIVONI SAS");
          pdf.text(445, 192, "231 RUE SAINT-HONORE");
          pdf.text(498, 204, "75001 PARIS");
          pdf.text(447, 216, "N° Siret: 80878516600048");
          pdf.text(501, 228, "NAF: 58.29C");
          pdf.text(436, 240, "EU VAT N°: FR32808785166");

          pdf.setFontSize(22);
          pdf.setFont("bold");
          pdf.setTextColor(95, 95, 95);
          pdf.text(42, 164, "CREDIT NOTE");
          pdf.setTextColor(81, 85, 236);
          pdf.text(2, 167, "_______________________");

          pdf.setTextColor(100);

          const d = new Date(cn.created);
          const yearDigits = d.getFullYear().toString().substr(-2);
          const cnNumericId = String(cn.id);
          const creditNoteId =
            yearDigits + "CN" + cnNumericId.padStart(10, "0");

          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const year = d.getFullYear().toString();
          const creditNoteDateStr =
            d.getDate() + " " + monthNames[d.getMonth()] + ", " + year;

          pdf.setFont("normal");
          pdf.setFontSize(11);
          pdf.text(40, 185, "Credit note number: " + creditNoteId);
          pdf.text(40, 200, "Credit note date: " + creditNoteDateStr);

          const clientLabel = cn.name || cn.client_name;
          if (clientLabel) {
            pdf.setFontSize(12);
            pdf.setTextColor(150);
            pdf.text(40, 230, "Credit note to: ");
            pdf.setFontSize(10);
            pdf.setFont("bold");
            pdf.text(40, 245, clientLabel);
            pdf.setFont("normal");
            pdf.text(40, 260, cn.legal_representative || "");
            pdf.text(40, 275, cn.address || "");
            pdf.text(40, 290, cn.country || "");
          }

          if (cn.vat_number != null && cn.vat_number !== "") {
            pdf.text(40, 305, "EU VAT N°: " + cn.vat_number);
          }

          pdf.autoTableSetDefaults({
            headStyles: { fillColor: [81, 85, 236] },
          });

          const total = Number(cn.amount || 0).toFixed(2);
          const percentage = cn.vat || 0;
          const totalWithVat = cn.amount_with_vat || 0;
          const totalVat = cn.amount_vat || 0;

          const lines = [
            {
              date: creditNoteDateStr,
              description: cn.description || "",
              total: total + " €",
              _isBold: true,
            },
          ];

          pdf.autoTable({
            startY: 320,
            body: lines,
            columns: [
              { header: "Date", dataKey: "date" },
              { header: "Description", dataKey: "description" },
              { header: "Total in EUR", dataKey: "total" },
            ],
            margin: { left: 40, right: 40 },
            styles: {
              fontSize: 6,
              cellPadding: 5,
              overflow: "linebreak",
            },
            columnStyles: {
              0: { cellWidth: 50 },
              1: { cellWidth: "auto" },
              2: { cellWidth: 50, halign: "right" },
            },
            didDrawCell: function (hookData) {
              if (hookData.section === "body") {
                const currentLine = lines[hookData.row.index];
                if (currentLine && currentLine._isBold) {
                  for (const cell of Object.values(hookData.row.cells)) {
                    cell.styles.fontStyle = "bold";
                  }
                }
              }
            },
          });

          const body = [];
          body.push({ field: "Subtotal in EUR", value: total + " €" });
          body.push({
            field: "VAT (" + percentage + "%)",
            value: totalVat + " €",
          });
          body.push({ field: "Total in EUR", value: totalWithVat + " €" });
          pdf.autoTable({
            startY: pdf.lastAutoTable.finalY + 40,
            tableWidth: 200,
            theme: "grid",
            minCellHeight: 30,
            margin: { left: 350 },
            head: [{ field: "", value: "" }],
            body: body,
            showHead: false,
            columnStyles: {
              field: { fontStyle: "bold", cellPadding: 7 },
              value: { cellPadding: 7, halign: "right" },
            },
          });

          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 20,
            "The invoice was generated electronically and automatically, without a cash register."
          );
          pdf.text(
            40,
            pdf.lastAutoTable.finalY + 35,
            "This is the original electronic version."
          );

          pdf.save("credit-note-" + creditNoteId + ".pdf");
        })
        .catch((error) => {
          console.error("Error descargando PDF credit note:", error);
        });
    },
  },
};
